import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import {
  getOptionListStylesAsClassName,
  getOptionListHeightStyle,
} from './option-list-styles';

export interface IOptionListProps {
  /** Number of maximum visible options in the container without scroll */
  maxVisibleOptions?: number;
  /** Add half of the heigth of an option to the containers height */
  addHalfOption?: boolean;
}

export const OptionList = ({
  maxVisibleOptions = 5,
  addHalfOption = true,
  children,
}: WithChildrenCommonProps<IOptionListProps>): JSX.Element => {
  const totalNumberOfItems = React.Children.toArray(children).length;
  const roundedMaxVisibleOptions =
    maxVisibleOptions >= totalNumberOfItems
      ? totalNumberOfItems
      : maxVisibleOptions + (addHalfOption ? 0.5 : 0);

  return (
    <div
      role="menu"
      className={getOptionListStylesAsClassName}
      style={{ height: getOptionListHeightStyle(roundedMaxVisibleOptions) }}
    >
      {children}
    </div>
  );
};
